import React from "react";
import { ShieldCheckIcon, DocumentTextIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen h-full bg-gray-50 overflow-y-scroll">

      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <header className="mb-8 border-b border-gray-200 pb-6">
          <button
            onClick={() => navigate("/")}
            className="flex items-center text-indigo-600 hover:text-indigo-800 transition font-medium mb-4"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </button>
          <div className="flex items-center gap-3 mb-4">
            <ShieldCheckIcon className="h-8 w-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900 font-serif">Privacy Policy</h1>
          </div>
       
        </header>

        <div className="bg-white rounded-lg shadow-sm p-8">
          <section className="mb-10">
            <p className="text-gray-600 mb-6 leading-relaxed">
              "Dairy Khatabook" we is committed to protecting 
              your privacy. This Privacy Policy outlines our practices regarding the collection, 
              use, and disclosure of your information through our services.
            </p>
          </section>

          {[
            {
              title: "1. Information We Collect",
              content: "We collect personal and operational data necessary for dairy management, including but not limited to: contact information, business details, transaction records, and system usage data."
            },
            {
              title: "2. Use of Information",
              content: "Collected data is used to: provide and improve services, facilitate transactions, maintain system security, communicate updates, and comply with legal obligations."
            },
            {
              title: "3. Data Security",
              content: "We implement enterprise-grade security measures including encryption, access controls, and regular audits. While we employ industry best practices, no electronic storage is completely secure."
            },
            {
              title: "4. Data Sharing",
              content: "Information may be shared with: service providers under confidentiality agreements, legal authorities when required, and business successors during mergers/acquisitions."
            },
            {
              title: "5. Your Rights",
              content: "You may request: access to your data, corrections to inaccuracies, deletion of non-essential data, and export of your information in machine-readable format."
            },
            {
              title: "6. Policy Updates",
              content: "We will notify users of material changes through our platform or email. Continued use after updates constitutes acceptance of revised terms."
            }
          ].map((section, index) => (
            <section key={index} className="mb-8">
              <div className="flex items-baseline gap-2 mb-3">
                <DocumentTextIcon className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <h2 className="text-xl font-semibold text-gray-900">{section.title}</h2>
              </div>
              <p className="text-gray-600 ml-7 leading-relaxed">{section.content}</p>
            </section>
          ))}

          <div className="mt-10 p-6 bg-blue-50 rounded-lg">
            <div className="flex items-start gap-3">
              <EnvelopeIcon className="h-6 w-6 text-blue-600 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Contact Information</h3>
                <p className="text-gray-600">
                  For privacy concerns or data requests:<br />
                  Email: <span className="text-blue-600">dairyKhatabook@gmail.com</span><br />
                </p>
              </div>
            </div>
          </div>

          <footer className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center">
              © {new Date().getFullYear()} [Your Company Name]. All rights reserved.
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;